module.exports = __webpack_public_path__ + "static/media/redLaptop.4ca3b0bf.png";